import { render, staticRenderFns } from "./phoneBreadcrumb.vue?vue&type=template&id=2f5569d2&scoped=true&"
import script from "./phoneBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./phoneBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./phoneBreadcrumb.vue?vue&type=style&index=0&id=2f5569d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5569d2",
  null
  
)

export default component.exports